import React from 'react';
import { useMediaQuery } from '@mui/material';
import ResponsivePageMidOne from './ResponsivePageMidOne';
import PageMidOne from './PageMidOne';

function ResponsiveScreenPageMidOne() {
  // Use MUI's useMediaQuery hook to check screen size
  const isSmallerScreen = useMediaQuery('(max-width:1100px)');

  return isSmallerScreen ? <ResponsivePageMidOne /> : <PageMidOne />;
};
export default ResponsiveScreenPageMidOne;